// client/src/dnd/emitter_tool/engine/engine_parts/sprites/index.js
import SingleSource from "./SingleSource";
import MultiSource from "./MultiSource";
import AnimSource from "./AnimSource";

const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

/**
 * Normalizes a "selection" object into a concrete source.
 * @param {Record<string, PIXI.Texture>} textures
 * @param {Object} selection
 * @param {'single'|'multi'|'anim'} selection.mode
 * @param {string|null} selection.single
 * @param {string[]} selection.multi
 * @param {string[]} selection.anim
 * @param {number} selection.animFps
 * @returns {{ next(dt:number): PIXI.Texture }}
 */
export function buildSpriteSource(textures = {}, selection = {}) {
  const modeIn = String(selection?.mode || "single").toLowerCase();
  const names = Object.keys(textures || {});
  const has = (n) => !!textures?.[n];

  const singleName =
    selection?.single && has(selection.single)
      ? selection.single
      : names[0] || null;

  const multiList = Array.isArray(selection?.multi)
    ? selection.multi.filter(has)
    : [];

  const animList = Array.isArray(selection?.anim)
    ? selection.anim.filter(has)
    : [];

  const fps = clamp(Math.floor(selection?.animFps || 12), 1, 120);

  // Choose effective mode (exclusive)
  const mode =
    modeIn === "anim" && animList.length >= 1
      ? "anim"
      : modeIn === "multi" && multiList.length >= 1
      ? "multi"
      : "single";

  if (mode === "anim") return new AnimSource({ textures, list: animList, fps, loop: true });
  if (mode === "multi") return new MultiSource({ textures, list: multiList });

  // single
  const list = singleName ? [singleName] : [];
  return new SingleSource({ textures, list });
}

export { SingleSource, MultiSource, AnimSource };
